/**
 * Primary in-app routes for workspace modules — used for settings links and route guards.
 */

export const MODULE_PRIMARY_ROUTES: Record<string, string> = {
  strategy: '/prioritization/strategy',
  strategy_kernel: '/prioritization/strategy',
  planning: '/planning/plans',
  strategy_canvas: '/prioritization/strategy/canvas',
  v2mom: '/prioritization/strategy/v2mom',
  plan_drift: '/prioritization/monitor/drift',
  catchball: '/prioritization/catchball',
  stakeholder_pulse: '/prioritization/pulse',
  commitment_registry: '/prioritization/commitments',
  tournaments: '/prioritization/tournaments',
  delivery_tracking: '/prioritization/calibration',
  cost_of_delay: '/prioritization/tools/cost-of-delay',
  execution_recipe: '/prioritization/settings/work-types',
  backlog_health: '/prioritization/settings/backlog-health',
  elevation_platform: '/home',
  extended_navigation: '/prioritization/tools/relationship-scenario-planner',
  input_rounds: '/prioritization/input-rounds',
  design_hub: '/prioritization/cycle-design',
  intake_embed: '/prioritization/intake/embed',
  evidence: '/prioritization/monitor/evidence',
  org_hierarchy: '/prioritization/settings/org-hierarchy',
  attributes: '/prioritization/settings/attributes',
  reports: '/prioritization/reports',
  decision_rights: '/prioritization/cycles',
  lexicon: '/prioritization/lexicon',
  judgment_index: '/prioritization/insights/judgment-index',
  judgment_analytics: '/prioritization/insights/judgment-analytics',
  ambient_runtime: '/prioritization/settings/ambient-runtime',
  decision_brief: '/brief',
  // App Layer — consumer-simple apps (one route family per app)
  app_session: '/apps/session',
  app_rank: '/apps/rank',
  app_cut: '/apps/cut',
  app_session_import: '/apps/session-import',
  app_items: '/apps/items',
  app_viability: '/apps/viability',
  app_focus: '/apps/focus',
  app_intake: '/apps/intake',
  app_review: '/apps/review',
  app_classification: '/apps/classification',
  app_relationships: '/apps/relationships',
  app_align: '/apps/align',
  app_allocate: '/apps/allocate',
  app_offsite: '/apps/offsite',
  app_hire: '/apps/hire',
  app_vendor_select: '/apps/vendor-select',
  app_risk_triage: '/apps/risk-triage',
  app_post_mortem: '/apps/post-mortem',
  app_ask_the_room: '/apps/ask-the-room',
  app_start: '/apps/start',
  app_decisions: '/apps/decisions',
  app_mandate: '/apps/mandate',
  app_whats_next: '/apps/whats-next',
  app_first_100_days: '/apps/first-100-days',
};

export function getModulePrimaryRoute(moduleKey: string): string | undefined {
  return MODULE_PRIMARY_ROUTES[moduleKey];
}
